import { createModalDialog } from '@cliotech-web/modal-dialog';
import { localSaveRaw, localLoadRaw, readcookie  } from '../../storageService';
import {logMessage} from '../../js/common/logger';
import {preventBodyScroll} from '../../utils.js';

const text = require('./text.json');

import './modal.css';

let geoip_cookie = readcookie('geoip');


function redirect_agree() {
 window.location.href = EEA_COUNTRIES[geoip_cookie] != '' ? EEA_COUNTRIES[geoip_cookie] : "https://www.iforex.eu";
  try {
  logMessage({eid:'brokerChoice-agree'})
} catch (error) {
  console.error(error);
}
}


function redirect_decline() {
  preventBodyScroll();
  try {
    localSaveRaw("brokerChoice", "1");
    logMessage({eid:'brokerChoice-decline'});
  } catch (error) {
    console.error(error);
  }
}

function placeContent() {
  document.getElementsByClassName('md-btn-wrap')[0].setAttribute('data-content', text.text2);
}


let options = {
  id: 'broker-choice',
  name: 'string',
  title: text.title,
  closeButton: () => { return '' },
  message: text.text,
  commands: [{
    text: text.btn1,
    name: 'btn1',
    close: true,
    action: () => { redirect_agree(); return true }
  },
  {
    text: text.btn2,
    name: 'btn2',
    close: true,
    action: () => { redirect_decline(); return true }
  }],
  callBack: () => { placeContent() }
}

let brokerChoiceModalLoaded = false;
let eea_country = Object.keys(EEA_COUNTRIES).includes(geoip_cookie) ? true : false;


try {
  brokerChoiceModalLoaded = localLoadRaw("brokerChoice") ? true : false;
} catch (error) {
  console.error(error);
}

if (!brokerChoiceModalLoaded && eea_country) {
  preventBodyScroll();
  let modal = createModalDialog(options);
  modal.show();

}

